import {
  AssessmentExpiryOptionUnit,
  ReasonableAdjustmentsOptionKind,
} from 'generated/graphql';
import { Link } from '@spotted-zebra-uk/ui-components';
import styles from './AssessmentsSection.module.scss';

export const assessmentExpiryUnitToStrings = {
  [AssessmentExpiryOptionUnit.Day]: {
    singular: 'day',
    plural: 'days',
  },
};

export function getAssessmentExpiryUnitString(
  duration: number,
  unit: AssessmentExpiryOptionUnit
) {
  const unitStringObj = assessmentExpiryUnitToStrings[unit];
  return `${duration} ${
    duration === 1 ? unitStringObj.singular : unitStringObj.plural
  }`;
}

export const reasonableAdjustmentKindToLabelMap = {
  [ReasonableAdjustmentsOptionKind.ContactCompanyEmail]: (
    initialContactValue?: string
  ) => (
    <div className={styles.reasonableAdjustmentLabel}>
      Contact company{' '}
      <Link to={`mailto:${initialContactValue}` || '#'} target="_blank">
        Via Email
      </Link>
    </div>
  ),
  [ReasonableAdjustmentsOptionKind.ContactCompanyUrl]: (
    initialContactValue?: string
  ) => (
    <div className={styles.reasonableAdjustmentLabel}>
      Contact company{' '}
      <Link
        to={
          !initialContactValue
            ? '#'
            : initialContactValue.startsWith('http')
            ? initialContactValue
            : `https://${initialContactValue}`
        }
        target="_blank"
      >
        Via Website URL
      </Link>
    </div>
  ),
  [ReasonableAdjustmentsOptionKind.ContactCompanyGeneric]: () =>
    'Contact company via indirect contact',
  [ReasonableAdjustmentsOptionKind.EmailSz]: () => 'Email Spotted Zebra',
  [ReasonableAdjustmentsOptionKind.SelfServe]: () => 'Self-serve',
};

export const displayBooleanValueAsYesNo = (value: boolean | undefined) =>
  value ? 'Yes' : 'No';
